import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { StorageService } from 'src/app/services/storage.service';
import { FormDataFacade } from 'src/app/ngrx/form-data/form-data.facade';
import { ApiService } from 'src/app/services/api.service';
import { Network } from '@ngx-pwa/offline';

@Component({
  selector: 'app-update-to-server-modal',
  templateUrl: './update-to-server-modal.component.html',
  styleUrls: ['./update-to-server-modal.component.scss']
})

export class UpdateToServerModalComponent implements OnInit {
  selectedIDs: Array<number>;
  removeDataFN: any;
  currentNumber = 0;
  invalidMsgs = [];
  online$: boolean;
  constructor(
    public bsModalRef: BsModalRef,
    private fdFacade: FormDataFacade,
    private storage: StorageService,
    private api: ApiService,
    protected network: Network
  ) {}

  ngOnInit() {
    this.online$ = this.network.online;
    if (this.online$) {
      this.selectedIDs.forEach(
        apsReportLoadId => {
          this.fdFacade.getDataFromDB(
            apsReportLoadId.toString(), +this.storage.getLocalValue('selectedAssignedAgentId')
          ).then(
            DBdata => {
              if (DBdata !== null) {
                const jsonData = DBdata.toJSON();

                // remove the id for notes to avoid error
                if  (jsonData.data.notes !== undefined) {
                  jsonData.data.notes.map(
                    data => {
                      if (data.id !== undefined) {
                        delete data.id;
                      }
                      return data;
                    }
                  );
                }

                if  (jsonData.data.notes !== undefined) {
                  jsonData.data.assessments.map(
                    data => {
                      if (data.parentAssessment !== undefined) {
                        delete data.parentAssessment;
                      }
                      return data;
                    }
                  );
                }

                this.api.saveAndComplete(jsonData.data).subscribe(
                  () => {
                    this.currentNumber = this.currentNumber + 1;
                    if (this.currentNumber === this.selectedIDs.length) {
                      this.bsModalRef.hide();
                      this.removeDataFN();
                    }
                  }
                );
              } else {
                this.currentNumber = this.currentNumber + 1;
                if (this.currentNumber === this.selectedIDs.length) {
                  this.bsModalRef.hide();
                }
              }
            }
          );
        }
      );
    }
  }

  validateFields(jsonData) {
    const investigationData = JSON.parse(jsonData.investigation.json_data);
    const closingSummaryData = jsonData.closing_summary;
    const msg = [];
    investigationData.aps_report_load.victims.map(
      data => {
        if (this.checkIfEmpty(data.age)) {
          msg.push('CLIENT IDENTIFICATION & DEMOGRAPHICS - Age');
        }

        if (this.checkIfEmpty(data.demographics.gender)) {
          msg.push('CLIENT IDENTIFICATION & DEMOGRAPHICS - Gender');
        }

        if (this.checkIfEmpty(data.demographics.has_case_manager)) {
          msg.push('CLIENT IDENTIFICATION & DEMOGRAPHICS - Does the client have a Case Manager?');
        }
    });

    if (
      (this.checkIfEmpty(investigationData.aps_report_load.referral_criteria.vulnerability_mental)
      || investigationData.aps_report_load.referral_criteria.vulnerability_mental === false)
      && (this.checkIfEmpty(investigationData.aps_report_load.referral_criteria.vulnerability_physical)
      || investigationData.aps_report_load.referral_criteria.vulnerability_physical === false)
      && (this.checkIfEmpty(investigationData.aps_report_load.referral_criteria.vulnerability_unknown)
      || investigationData.aps_report_load.referral_criteria.vulnerability_unknown === false)
    ) {
      msg.push('INVESTIGATION - Identify observations, credible information, and factual statements regarding the vulnerabilities');
    }

    if (
      (this.checkIfEmpty(investigationData.aps_report_load.referral_criteria.alleged_maltreatment_neglect)
      || investigationData.aps_report_load.referral_criteria.alleged_maltreatment_neglect === false)
      && (this.checkIfEmpty(investigationData.aps_report_load.referral_criteria.alleged_maltreatment_abuse)
      || investigationData.aps_report_load.referral_criteria.alleged_maltreatment_abuse === false)
      && (this.checkIfEmpty(investigationData.aps_report_load.referral_criteria.alleged_maltreatment_exploitation)
      || investigationData.aps_report_load.referral_criteria.alleged_maltreatment_exploitation === false)
      && (this.checkIfEmpty(investigationData.aps_report_load.referral_criteria.alleged_maltreatment_self_neglect)
      || investigationData.aps_report_load.referral_criteria.alleged_maltreatment_self_neglect === false)
    ) {
      msg.push('INVESTIGATION - Identify observations, credible information, and factual statements regarding the maltreatment');
    }

    if (this.checkIfEmpty(investigationData.aps_report_load.incident_addresses[0].maltreatment_setting)) {
      msg.push('INVESTIGATION - Maltreatment Setting');
    }

    if (this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_care_planning_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_caregiver_support_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_community_day_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_education_employment_training_services)
    && this.checkIfEmptyAndFalse(
      investigationData.aps_report_load.services_or_referrals_made.sas_emergency_assistance_and_material_aid_services
    )
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_financial_planning_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_housing_and_relocation_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_in_home_assistance_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_education_employment_training_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_medical_and_dental_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_medical_rehabilitation_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_mental_health_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_nutrition)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_public_assistance_benefits)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_substance_use_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_transportation)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_victim_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_other_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sas_none)
    ) {
      msg.push('INVESTIGATION - Services at Start');
    }

    if (this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sapdi_care_planning_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sapdi_caregiver_support_services)
    && this.checkIfEmptyAndFalse(
      investigationData.aps_report_load.services_or_referrals_made.sapdi_emergency_assistance_and_material_aid_services
    )
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sapdi_housing_and_relocation_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sapdi_transportation)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sapdi_none)
    ) {
      msg.push('INVESTIGATION - Services APS Provided During Investigation');
    }

    if (this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_care_planning_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_caregiver_support_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_community_day_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_education_employment_training_services)
    && this.checkIfEmptyAndFalse(
      investigationData.aps_report_load.services_or_referrals_made.srba_emergency_assistance_and_material_aid_services
    )
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_financial_planning_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_housing_and_relocation_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_in_home_assistance_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_education_employment_training_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_medical_and_dental_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_medical_rehabilitation_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_mental_health_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_nutrition)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_public_assistance_benefits)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_substance_use_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_transportation)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_victim_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_other_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.srba_none)
    ) {
      msg.push('INVESTIGATION - Services Referred by APS');
    }

    if (this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_care_planning_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_caregiver_support_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_community_day_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_education_employment_training_services)
    && this.checkIfEmptyAndFalse(
      investigationData.aps_report_load.services_or_referrals_made.sac_emergency_assistance_and_material_aid_services
    )
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_financial_planning_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_housing_and_relocation_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_in_home_assistance_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_education_employment_training_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_medical_and_dental_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_medical_rehabilitation_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_mental_health_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_nutrition)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_public_assistance_benefits)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_substance_use_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_transportation)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_victim_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_other_services)
    && this.checkIfEmptyAndFalse(investigationData.aps_report_load.services_or_referrals_made.sac_none)
    ) {
      msg.push('INVESTIGATION - Services at Close');
    }

    closingSummaryData.aps_findings_outcomes.map(
      data => {
        if (this.checkIfEmpty(data.findings)
        || this.checkIfEmpty(data.findings.name)) {
          msg.push(`CLOSING SUMMARY - ${data.type_of_maltreatment} - Findings`);
        }
        if (this.checkIfEmpty(data.outcome)
        || this.checkIfEmpty(data.outcome.name)) {
          msg.push(`CLOSING SUMMARY - ${data.type_of_maltreatment} - Outcome`);
        }
        if (this.checkIfEmpty(data.client_risk_conclusion)
        || this.checkIfEmpty(data.client_risk_conclusion.name)) {
          msg.push(`CLOSING SUMMARY - ${data.type_of_maltreatment} - Client Risk Conclusion`);
        }
      }
    );

    if (this.checkIfEmpty(closingSummaryData.did_aps_enter_home) ||
    this.checkIfEmpty(closingSummaryData.did_aps_enter_home.name)) {
      msg.push('CLOSING SUMMARY - Did APS enter the home?');
    }
    if (this.checkIfEmpty(closingSummaryData.reason_for_closure)
    || this.checkIfEmpty(closingSummaryData.reason_for_closure.name)) {
      msg.push('CLOSING SUMMARY - Reason for Closure');
    }


    if (msg.length > 0) {
      this.invalidMsgs.push({
        name: `${investigationData.aps_report_load.victims[0].last_name}, ${investigationData.aps_report_load.victims[0].first_name}`,
        validations: msg
      });
      return true;
    }
    return false;
  }

  checkIfEmpty(value: any) {
    return value === '' || value === undefined || value === null;
  }

  checkIfEmptyAndFalse(value: any) {
    return this.checkIfEmpty(value) || value === false;
  }

}
